import React, { useState } from "react";
import { Formik, FormikProps } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Backdrop,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import globalClasses from "../../component/commoncomponents/css/Global.module.css";
import InputField from "../commoncomponents/input/InputField";
import ButtonComponent from "../commoncomponents/buttons/ButtonComponent";
import { getRequest } from "../../api/AxiosAPICall";
import SignInLink from "../commoncomponents/link/SignInLink";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../commoncomponents/alert/SnackbarAction";

const theme = createTheme();
const PasswordVerification = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  let history = useNavigate();

  const sendPasswordRecoveryEmail = async (values: any) => {
    setIsLoading(true);

    const response = await getRequest("sendPasswordRecoveryEmail", {
      params: {
        email: values.email,
      },
    });

    setIsLoading(false);
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else if (response.data === "EMAIL SENT") {
      dispatch(
        setSnackbar(
          true,
          3000,
          "success",
          "Your unique key has been sent to your registered email address.",
          "top",
          "center"
        )
      );
      setTimeout(() => {
        history("/forgotpassword", { state: { userEmail: values } });
      }, 2500);
    } else if (response.data === "UNABLE TO SEND EMAIL") {
      dispatch(
        setSnackbar(
          true,
          4000,
          "warning",
          "Unable to send email.",
          "top",
          "center"
        )
      );
    } else if (response.data === "UNABLE TO FIND USER") {
      dispatch(
        setSnackbar(
          true,
          4000,
          "warning",
          "If we find this email address in our system, you will receive an email for unique key.",
          "top",
          "center"
        )
      );
    }
  };

  return (
    <Formik
      //********Using Yup for validation********/
      initialValues={{ email: "" }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .required("Email Required")
          .email("Please enter valid email."),
      })}
      onSubmit={() => {}}
    >
      {(data: FormikProps<any>) => {
        return (
          <>
            <form onSubmit={data.handleSubmit}>
              <CommonLayout>
                <ThemeProvider theme={theme}>
                  <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                      sx={{
                        marginTop: 20,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography component="h1" variant="h5" sx={{ mb: -1 }}>
                        Reset Your Password
                      </Typography>
                      <Box sx={{ mt: 1 }} className={globalClasses.boxGrid}>
                        <Typography
                          component="h6"
                          variant="h6"
                          sx={{ fontSize: "15px", marginBottom: "10px" }}
                        >
                          To reset your password, please enter the email address
                          you use to sign in.
                        </Typography>

                        <InputField
                          id="email"
                          name="email"
                          label="Email Address"
                          inputvalues={data.values.email}
                          changeevent={data.handleChange}
                          blurevent={data.handleBlur}
                          errormessage={
                            data.touched.email && Boolean(data.errors.email)
                          }
                          message={data.touched.email && data.errors.email}
                          isrequired={true}
                        />

                        <ButtonComponent
                          buttonclass={globalClasses.forgotPasswordButton}
                          fullWidth
                          label="Continue"
                          onClick={(event: any) => {
                            data.handleSubmit(event);

                            if (
                              data.values.email !== null &&
                              data.values.email !== ""
                            ) {
                              sendPasswordRecoveryEmail(data.values);
                            }
                          }}
                        />
                      </Box>
                      {isLoading && (
                        <Box>
                          <Backdrop open>
                            <CircularProgress
                              className={globalClasses.circularProgress}
                            />
                          </Backdrop>
                        </Box>
                      )}

                      <SignInLink />
                    </Box>
                  </Container>
                </ThemeProvider>
              </CommonLayout>
            </form>
          </>
        );
      }}
    </Formik>
  );
};

export default PasswordVerification;
